<template>
  <div
    class="cursor-pointer ease-in-out text-center inline-block px-2"
    @click="$emit('click')"
  >
    <p
      class="uppercase font-semibold text-xl opacity-50"
      :class="[selected ? `opacity-100` : '']"
    >
      {{ dayOfWeek }}
    </p>
  </div>
</template>

<script>
export default {
  name: "AgendaHeader",
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    dayOfWeek: {
      type: String,
      required: true
    },
    day: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
